import { UserOverviewFiltration } from 'entities/userOverview';
import { ICustomColumnType } from 'shared/ui/VirtualTable';

import getUserOverviewNameCell from './ui/getUserOverviewNameCell';
import { DataType } from './UserOverviewWidget.types';

export const PAGE_SIZE = 40;
export const THRESHOLD_VALUE = 5;
export const ROW_HEIGHT = 32;

export const DEFAULT_FILTRATION: UserOverviewFiltration = {
  showOnlyNonBillable: false,
  availableUsers: true,
  filters: [],
  orders: [
    { fieldName: 'firstName', orderDirection: 'ASC' },
    { fieldName: 'lastName', orderDirection: 'ASC' },
  ],
};

export const columns: ICustomColumnType<DataType>[] = [
  {
    title: 'UserOverview:UserTable.header.column.name.title',
    dataIndex: 'name',
    key: 'name',
    ellipsis: {
      showTitle: false,
    },
    sorter: false,
    width: '30%',
    minWidth: 250,
    render: getUserOverviewNameCell,
  },
  {
    title: 'UserOverview:UserTable.header.column.seniority.title',
    dataIndex: 'seniority',
    key: 'seniority',
    ellipsis: {
      showTitle: false,
    },
    sorter: false,
    width: '17.5%',
    minWidth: 150,
  },
  {
    title: 'UserOverview:UserTable.header.column.specialization.title',
    dataIndex: 'specialization',
    key: 'specialization',
    ellipsis: {
      showTitle: false,
    },
    sorter: false,
    width: '17.5%',
    minWidth: 150,
  },
  {
    title: 'UserOverview:UserTable.header.column.workProfile.title',
    dataIndex: 'workProfile',
    key: 'workProfile',
    ellipsis: {
      showTitle: false,
    },
    sorter: false,
    width: '17.5%',
    minWidth: 150,
  },
  {
    title: 'UserOverview:UserTable.header.column.manager.title',
    dataIndex: 'managerBamboo',
    key: 'managerBamboo',
    ellipsis: {
      showTitle: false,
    },
    sorter: false,
    width: '17.5%',
    minWidth: 150,
  },
];
